import { NGRX_BUCKETS, Role, Site, User } from '@curbnturf/entities';
import { siteComplete } from '@curbnturf/helpers';
import * as UserSelectors from '@curbnturf/user/src/lib/+state/user.selectors';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SiteState } from './site.reducer';

export const getSiteFeatureState = createFeatureSelector<SiteState>(NGRX_BUCKETS.site);

export const getSiteEntities = createSelector(getSiteFeatureState, (state: SiteState) => {
  if (state && state.sites) {
    const instantiatedSites: { [id: number]: Site } = {};
    state.sites.forEach((site) => {
      if (site.id) {
        instantiatedSites[site.id] = new Site(site);
      }
    });

    return instantiatedSites;
  }

  return {};
});

export const getSites = createSelector(getSiteFeatureState, (state: SiteState): Site[] =>
  state.sites.map((el) => new Site({ ...el })),
);

export const getError = createSelector(getSiteFeatureState, (state: SiteState): string | undefined => state && state.error);

export const getLoaded = createSelector(getSiteFeatureState, (state: SiteState): boolean => (state && state.loaded) || false);

export const getSitesReadyToEnable = createSelector(
  getSites,
  UserSelectors.getCurrentUser,
  (sites: Site[], user: User): Site[] =>
    sites.filter(
      (site) =>
        site.listing?.user &&
        (site.listing.user.id === user.id || user.role === Role.admin) &&
        !site.available &&
        siteComplete.completed({ ...site, listing: {...site.listing, user }}),
    ),
);

export const getSelectedSiteId = createSelector(getSiteFeatureState, (state) => state && state.selected);

export const getSelectedSite = createSelector(getSites, getSelectedSiteId, (sites, selected) =>
  !selected ? null : new Site(sites.find((el) => el.id === selected || el.syncId === selected)),
);
